<template>
    <div>
        <div id="catalog-layout" class="layout">
            <nav-bar :user-logged-in="userLoggedIn"></nav-bar>

            <slot></slot>

            <component :is="getFooterComponent()"></component>
        </div>
        <cookie-consent-box></cookie-consent-box>
    </div>
</template>

<script>
import Vue from "vue";
import NavBar from '../components/organisms/NavBar'
import FooterBar from '../components/organisms/FooterBar.vue'
import FooterBarCanada from '../components/organisms/FooterBarCanada.vue'
import CookieConsentBox from "../components/molecules/CookieConsentBox.vue";

export default Vue.extend({
    components: { 
        NavBar, 
        FooterBar,
        FooterBarCanada,
         CookieConsentBox
    },
    data() {
        return {
            whitelistPages: null
        }
    },
    computed: {
        userLoggedIn() {
            return this.$root.user.isLoggedIn()
        }
    },
    methods: {
        handleClosedShop() {
            const isClosed = this.$root.whitelabel.setting('accessibility') === 'closed'
            const whitelist = this.$root.whitelabel.setting('accessibility_whitelist')
            this.whitelistPages = whitelist ? whitelist.split('\r\n') : null

            if(isClosed) {
                if (!this.$root.user.isLoggedIn()) {
                    if(this.whitelistPages !== null) {
                        if(!this.refererIsOnWhitelist()){
                            this.redirectToLogin()
                        }
                    } else {
                        this.redirectToLogin()
                    }
                }
            }
        },
        redirectToLogin () {
            this.$goTo('login')
        },
        refererIsOnWhitelist () {
            const refererPage = document.getElementById('referer').value
            let isOneWhitelist = false

            this.whitelistPages.forEach(value => {
                if(refererPage.includes(value)){
                    isOneWhitelist = true
                }
            });

            return isOneWhitelist
        },
        getFooterComponent() {
            return this.$root.whitelabel.getFooterLayout();
        },

    },
    mounted() {
        this.handleClosedShop()
    },
    head: {
        link: function () {
            return [
                { r: 'icon', h: this.$root.whitelabel.buildFaviconUrl(16), sz: '16x16', t: 'image/png' },
                { r: 'icon', h: this.$root.whitelabel.buildFaviconUrl(32), sz: '32x32', t: 'image/png' },
                { r: 'icon', h: this.$root.whitelabel.buildFaviconUrl(150), sz: '150x150', t: 'image/png' },
                { r: 'icon', h: this.$root.whitelabel.buildFaviconUrl(192), sz: '192x192', t: 'image/png' },
            ]
        }
    }
})
</script>
